import React from 'react'
import Loader from '../../../components/Loader'

const LoadMoreSpinner = (
  <div className='col-12 m-3 d-flex justify-content-center'>
    <Loader isLoading />
  </div>
)

export default LoadMoreSpinner